import { RenovateScoreCard } from './renovateScoreCard/RenovateScoreCard';
import { SecretsScoreCard } from './secretsScoreCard/secretsScoreCard';
import { Team } from '@internal/schemas-common';
import { VulnerabilitiesScoreCard } from './vulnerabilitiesScoreCard/VulnerabilitiesScoreCard';

export type ScoreCardHomePage<T> = {
  title: string;
  tooltip: string;
  deepLinkTitle: string;
  Component: React.ComponentType<any>;
  props: T;
};

export function getScoreCardsHomePage(
  team: Team,
  renovateData: any,
  vulnerabilitiesData: any,
  secretsData: any,
  longestOutdatedSecret: number,
): Array<ScoreCardHomePage<any>> {
  return [
    {
      title: team.name,
      tooltip: `Renovate Score Card\nTeam: ${team.name}\nInfo: To benefit from Renovate, you need to act on your Merge Requests. If left unchecked, they can trigger excessive CI runs, leading to unnecessary load and costs.`,
      deepLinkTitle: 'See Details',
      Component: RenovateScoreCard,
      props: {
        score: renovateData,
        link: `${team.portalTeamPageHref}/renovate`,
      },
    },
    {
      title: team.name,
      tooltip: `Vulnerabilities Score Card\nTeam: ${team.name}\nInfo: Vulnerabilities can be exploited by attackers, potentially compromising SCALAR.`,
      deepLinkTitle: 'See Details',
      Component: VulnerabilitiesScoreCard,
      props: {
        score: vulnerabilitiesData,
        link: `${team.portalTeamPageHref}/vulnerabilities`,
      },
    },
    {
      title: team.name,
      tooltip: `Secrets Score Card\nTeam: ${team.name}\nInfo: In line with our security guidelines, secrets must be rotated annually.`,
      deepLinkTitle: 'See Details',
      Component: SecretsScoreCard,
      props: {
        score: secretsData,
        longestOutdatedSecret,
        link: `${team.portalTeamPageHref}/secrets`,
      },
    },
  ];
}
